import { forwardRef, type SelectHTMLAttributes } from 'react';

import { cn } from '../lib/cn';

import s from './Select.module.css';

type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className, children, ...rest },
  ref,
) {
  return (
    <span className={s.wrap}>
      <select ref={ref} className={cn(s.root, className)} {...rest}>
        {children}
      </select>
      <svg
        className={s.caret}
        viewBox="0 0 12 12"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M2.5 4.5 6 8l3.5-3.5" />
      </svg>
    </span>
  );
});
